import React__default, { memo } from 'react';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Handle } from './handle.js';
import { Highlight } from './highlight.js';
import { Track } from './track.js';

var _excluded = ["name", "onChange", "value", "minValue", "maxValue", "orientation", "stepSize", "children"];
var closest = function closest(value, arr) {
  return arr.reduce(function (prev, curr) {
    return Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev;
  });
};
var RangeSlider = /*#__PURE__*/memo(function (rawProps) {
  var name = rawProps.name,
    onChange = rawProps.onChange,
    value = rawProps.value,
    _rawProps$minValue = rawProps.minValue,
    minValue = _rawProps$minValue === void 0 ? 0 : _rawProps$minValue,
    maxValue = rawProps.maxValue,
    _rawProps$orientation = rawProps.orientation,
    orientation = _rawProps$orientation === void 0 ? "horizontal" : _rawProps$orientation,
    _rawProps$stepSize = rawProps.stepSize,
    stepSize = _rawProps$stepSize === void 0 ? 1 : _rawProps$stepSize,
    children = rawProps.children,
    restProps = _objectWithoutPropertiesLoose(rawProps, _excluded);
  var onChangeMin = function onChangeMin(v) {
    onChange({
      min: v < value.max ? v : value.max - stepSize,
      max: value.max
    });
  };
  var onChangeMax = function onChangeMax(v) {
    onChange({
      min: value.min,
      max: v > value.min ? v : value.min + stepSize
    });
  };
  return /*#__PURE__*/React__default.createElement(Track, _extends({}, restProps, {
    minValue: minValue,
    maxValue: maxValue,
    orientation: orientation,
    stepSize: stepSize,
    variant: rawProps.variant,
    onClick: function onClick(v) {
      var c = closest(v, [value.min, value.max]);
      onChange({
        min: c === value.min ? v : value.min,
        max: c === value.max ? v : value.max
      });
    }
  }), /*#__PURE__*/React__default.createElement("input", {
    name: (typeof name === "undefined" ? "" : name) + "_start",
    value: value.min,
    type: "hidden"
  }), /*#__PURE__*/React__default.createElement("input", {
    name: (typeof name === "undefined" ? "" : name) + "_end",
    value: value.max,
    type: "hidden"
  }), /*#__PURE__*/React__default.createElement(Highlight, {
    minValue: minValue,
    start: value.min,
    end: value.max
  }), /*#__PURE__*/React__default.createElement(Handle, {
    "aria-valuemin": minValue,
    "aria-valuemax": maxValue,
    value: value.min,
    onChange: onChangeMin
  }), /*#__PURE__*/React__default.createElement(Handle, {
    "aria-valuemin": minValue,
    "aria-valuemax": maxValue,
    value: value.max,
    onChange: onChangeMax
  }), children);
});

export { RangeSlider };
//# sourceMappingURL=range-slider.js.map
